export const IsBrowser = () => typeof window !== "undefined";
